import { pluginImage } from 'wix-rich-content-plugin-image';
import { pluginVideo } from 'wix-rich-content-plugin-video';
import { pluginFileUpload } from 'wix-rich-content-plugin-file-upload';
import { pluginDivider } from 'wix-rich-content-plugin-divider';
import { pluginHtml } from 'wix-rich-content-plugin-html';
import { pluginCodeBlock } from 'wix-rich-content-plugin-code-block';
import { pluginGiphy } from 'wix-rich-content-plugin-giphy';
import { pluginEmoji } from 'wix-rich-content-plugin-emoji';
import { pluginVerticalEmbed } from 'wix-rich-content-plugin-vertical-embed';
import { pluginLink } from 'wix-rich-content-plugin-link';
import { pluginLinkPreview } from 'wix-rich-content-plugin-link-preview';
import { pluginTextColor, pluginTextHighlight } from 'wix-rich-content-plugin-text-color';
import { pluginHashtag } from 'wix-rich-content-plugin-hashtag';
import { pluginMentions } from 'wix-rich-content-plugin-mentions';
import { pluginSpoiler } from 'wix-rich-content-plugin-spoiler';
import { pluginCollapsibleList } from 'wix-rich-content-plugin-collapsible-list';
import { pluginPoll } from 'wix-rich-content-plugin-social-polls';
import { PLUGINS } from '@wix/communities-forum-client-commons';

export const editorPluginModules = {
  [PLUGINS.IMAGE]: pluginImage,
  [PLUGINS.VIDEO]: pluginVideo,
  [PLUGINS.FILE_UPLOAD]: pluginFileUpload,
  [PLUGINS.GIPHY]: pluginGiphy,
  [PLUGINS.EMOJI]: pluginEmoji,
  [PLUGINS.CODE_BLOCK]: pluginCodeBlock,
  [PLUGINS.COLLAPSIBLE_LIST]: pluginCollapsibleList,
  [PLUGINS.DIVIDER]: pluginDivider,
  [PLUGINS.HTML]: pluginHtml,
  [PLUGINS.VERTICAL_EMBED]: pluginVerticalEmbed,
  [PLUGINS.LINK]: pluginLink,
  [PLUGINS.LINK_PREVIEW]: pluginLinkPreview,
  [PLUGINS.TEXT_COLOR]: pluginTextColor,
  [PLUGINS.TEXT_HIGHLIGHT]: pluginTextHighlight,
  [PLUGINS.HASHTAG]: pluginHashtag,
  [PLUGINS.MENTIONS]: pluginMentions,
  [PLUGINS.SPOILER]: pluginSpoiler,
  [PLUGINS.POLLS]: pluginPoll,
};
